<script setup lang="ts">
import Button from '@/components/Button.vue';
import iconDiscovery from "@/components/icons/iconDiscovery.vue";
import iconSolution from "@/components/icons/iconSolution.vue";
import iconImplementation from "@/components/icons/iconImplementation.vue";
import iconSupportWaste from "@/components/icons/iconSupportWaste.vue";
import iconRefine from "@/components/icons/iconRefine.vue";
import AltraIcon from "@/components/AltraIcon.vue";

const route = useRoute()
const routeName = computed(() => route.name)

const emit = defineEmits<{
  (e: 'toggle'): void
}>()


const router = useRouter()

function redirect(path: string) {

  
  router.push(path)

  nextTick(() => {
    emit('toggle')
    
  })
}

</script>

<template>
<Frame id="mega-about" class="io-mega-popover sec-popover-container popover-about mega-about" >
  <Frame class="sec-mega-container" w="grid grid-cols-[0.8fr_1fr_1fr] g-1">
    <Frame class="column-1 column mega-column-hero-title" w="flex flex-col g-1 items-start max-w-92%">
        
        <div class="gpt-1.5 sec-primary-title ">
          <div class="font-secondary glh-2">The 360<span class="deg">°</span> Altracare Experience</div>
          <div class="line" />
        </div>
        <div class="sec-primary-content">
          <p>At Altracare, we don’t just supply hygiene products — we partner with you to raise standards across every part of your operation. What sets us apart is our 360° Service model. The result? Spotless results, confident teams, and assured compliance.</p>
        </div>
        <div class="sec-actions">
          <div class="action btn-learn">
            <Button btn="blue" class="gpy-0.5 gpx-1.25 fs--1 fw-600 flex items-center g-0.5" @click="redirect('/our-service')">
              Learn more
            </Button>
          </div>
        </div>
      

    </Frame>
    <Frame class="column-2 column col-link-cards" w="grid g-0.5">
        <div class="mega-column-title" >
          <div>Our 360-Degree Service</div>
        </div>
        <div class="sec-link-cards grid !g-0.25 solutions">

          <a class="sec-nav-card-link feature" @click="redirect('/our-service?discovery')">
            <div class="wrap">
              <div class="icon">
                <iconDiscovery class="c-icon icon-discovery" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Assessment & Discovery</h3>
                <p class="linkSub">Tailored site assessments to understand your unique challenges and goals.</p>
              </div>
            </div>
          </a>
          <a class="sec-nav-card-link feature" @click="redirect('/our-service?solutions')">
            <div class="wrap">
              <div class="icon">
                <iconSolution class="c-icon icon-solution" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Tailored Solutions</h3>
                <p class="linkSub">Hygiene plans designed for performance, safety, and eco-efficiency.</p>
              </div>
            </div>
          </a>
          <a class="sec-nav-card-link feature" @click="redirect('/our-service?implementation')">
            <div class="wrap">
              <div class="icon">
                <iconImplementation class="c-icon icon-implementation" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Implementation & Training</h3>
                <p class="linkSub">Seamless setup with expert installation and practical staff training.</p>
              </div>
            </div>
          </a>
          <a class="sec-nav-card-link feature" @click="redirect('/our-service?support')">
            <div class="wrap"> 
              <div class="icon">
                <iconSupportWaste class="c-icon icon-support-waste" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Ongoing Support</h3>
                <p class="linkSub">Regular audits, technical visits, and compliance monitoring that keep you inspection-ready.</p>
              </div>
            </div>
          </a>
          <a class="sec-nav-card-link feature" @click="redirect('/our-service?refine')">
            <div class="wrap"> 
              <div class="icon">
                <iconRefine class="c-icon icon-refine" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Continuous Improvement</h3>
                <p class="linkSub">Reviews, innovation and refinements that ensure you stay ahead year after year.</p>
              </div>
            </div>
          </a>

        </div>
      </Frame>
      <Frame class="column-3 column col-link-cards" w="grid g-1">
        <div class="mega-column-title">
          <div>AltraCare</div>
        </div>
        <div class="sec-link-cards flex flex-col items-start">

          <a class="sec-nav-card-link simple services" :class="{'active': route.name === 'our-service'}" @click="redirect('/our-service')">
            <div class="wrap"> 
              <div class="icon">
                
              <svg width="17" height="17"><path fill="#87BBFD" class="hover-fillLight" d="M.945 1.998h3.632C6.744 1.998 8.5 3.005 8.5 4.83v11.583c-.512 0-1.015-.337-1.33-.59-1.03-.828-3.057-.828-5.222-.828H.945A.944.944 0 0 1 0 14.052V2.944C0 2.422.423 2 .945 2z"></path><path fill="#6772E5" class="hover-fillDark" d="M16.055 1.998h-3.632C10.257 1.998 8.5 3.005 8.5 4.83v11.583c.512 0 1.015-.337 1.33-.59 1.03-.828 3.057-.828 5.222-.828h1.003A.944.944 0 0 0 17 14.05V2.945A.944.944 0 0 0 16.055 2z"></path></svg>
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">360° Services</h3>
                <p class="linkSub">Explore our proven cycle of service excellence — from first consultation to continuous improvement.</p>
              </div>
            </div>
          </a>

          <a class="sec-nav-card-link simple services" :class="{'active': route.name === 'our-service'}" @click="redirect('/our-service')">
            <div class="wrap"> 
              <div class="icon">
                
              <AltraIcon class="w-22px h-22px" />

              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">About Us</h3>
                <p class="linkSub">Discover how Altracare has grown into a trusted partner for industries across Zanzibar and beyond, with a focus on sustainability, reliability, and local expertise.</p>
              </div>
            </div>
          </a>

        </div>
      </Frame>
  </Frame>
</Frame>
</template>

<style lang="scss" scoped>

</style>